import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useStore } from '../../../shared/store';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { formatDateTime, classNames } from '../../../utils';
import { Table } from '../../../elements/table';
import { Button } from '../../../elements/button';
import { FieldError } from '../../../elements/field-error/field-error';
import { DatePicker } from '../../../elements/date-picker';
import { Formik } from 'formik';


export const AsignacionesRelease = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { get, set } = useStore();
    const { api, state } = useHttpClient();
    const [step, setStep] = useState<string | null>('1');
    const [data, setData] = useState<any | null>(null);
    const [vehiculo, setVehiculo] = useState<any | null>({});

    const [date, setDate] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));


    const initialValues = {
        assignment_datetime: dayjs().format('YYYY-MM-DDTHH:mm:ss')
    };

    let obligado = {
        //assignment_datetime: Yup.string().required('obligatorio'),
    };

    const validacion = Yup.object().shape(obligado);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setDate(value);

    };


    useEffect(() => {
        const idConductor = get('idConductor')

        api(`/fleet/assignments/?driver=${idConductor}&is_active=true`, 'GET');

    }, []);

    const handleSelectVehiculo = (item: any) => {
        setVehiculo(item);
        setStep('2');
    };

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };


        const formattedDate = date ? new Date(date).toISOString().slice(0, 16) : "";

        after.completion_datetime = formattedDate || date;

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);
        // create
        api(`/fleet/assignments/${vehiculo.assignmentId}/release/`, 'POST', enviaremos);

    };


    useEffect(() => {
        if (state.data) {
            if (state.path.includes('/fleet/assignments/?driver')) {
                if (state.method === 'GET') {
                    const vehicles = state.data.results.map((item: any) => ({
                        ...item.vehicle,
                        assignmentId: item.id // Agregamos el id con el nombre 'assignmentId'
                    }));
                    setData(vehicles);

                }
            }
            if (state.path.includes('release')) {
                if (state.method === 'POST') {
                    toast.success(`${t('common.label.devolucion-existosa')}`);
                    navigate('/assignments/');
                }
            }

        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);

    return (
        <>
            {step === '1' ? <div className='py-4 px-8 w-full'>
                <div
                    className="pb-4 cursor-pointer"
                    onClick={() => navigate(-1)}
                >
                    <span className='text-black pt-[5px]'>{'< '}</span>
                    <span className='text-black text-[12px]'>{t('common.button.back')}</span>
                </div>
                <div className='p-8'>
                    <div className='text-[18px] text-gray-900 pb-8'>{t('common.label.devolver-vehiculo')}</div>
                    <Table
                        withPagination
                        parentData={data}
                        onSelection={handleSelectVehiculo}
                        noEdit={true}
                        noDelete={true}
                        headers={[
                            {
                                key: 'plate',
                                label: 'common.form-label.matricula'
                            },
                            {
                                key: 'available',
                                type: 'boolean',
                                label: 'common.form-label.disponible',
                            },
                            {
                                key: 'status',
                                type: 'status',
                                label: 'common.label.estado',
                            },
                            {
                                key: 'photo_display_url',
                                type: 'image',
                                label: 'common.form-label.foto',
                            },
                        ]}
                    />

                </div>
            </div> : ''}
            {step === '2' ? <div>
                <div className='flex p-8 mt-24'>
                    <div className='flex'>
                        {vehiculo?.photo_display_url ? <img className='h-[180px] pb-4 pr-4' src={vehiculo?.photo_display_url} /> : ''}
                    </div>
                    <div className='pl-8'>
                        <div className='flex'>
                            <div className="text-[20px]  text-gray-900 pr-4">
                                {t('common.label.vehiculo')}:
                            </div>
                            <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                                {vehiculo?.plate}
                            </div>
                        </div>
                        <div>
                            <Formik
                                enableReinitialize={true}
                                initialValues={initialValues}
                                validationSchema={validacion}
                                validateOnBlur={true}
                                onSubmit={onSubmit}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    setFieldValue,
                                    handleSubmit,
                                    isSubmitting
                                }) => (
                                    <form onSubmit={handleSubmit} autoComplete="off">
                                        <div className="flex">
                                            <div className="w-full">
                                                <div className="my-[11px] w-full">



                                                    {/* --------------------FECHA------------------- */}

                                                    {/*   <DatePicker
                                                        name="assignment_datetime"
                                                        type="date"
                                                        label={t('common.label.fecha-asignacion')}
                                                        value={dayjs().format('YYYY-MM-DD') || values.assignment_datetime}
                                                        onChange={(value: any) => {
                                                            setFieldValue(
                                                                'assignment_datetime',
                                                                value.assignment_datetime
                                                                    ? dayjs(value.assignment_datetime).format(
                                                                        'YYYY-MM-DD'
                                                                    )
                                                                    : null
                                                            );
                                                        }}
                                                    />
                                                    <FieldError touched={touched} errors={errors} field={"assignment_datetime"} /> */}
                                                    {/* --------------------FECHA------------------- */}
                                                    <div className="my-[11px] w-full">
                                                        {/* --------------------FECHA------------------- */}

                                                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                                                            {t('common.label.fecha-devolucion')}
                                                        </label>
                                                        <input
                                                            id="dateInput"
                                                            type="datetime-local"
                                                            step="1" // Permite solo minutos (sin segundos)
                                                            value={date} // Mostrar sin segundos en el input
                                                            onChange={handleChange}
                                                        />
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <Button
                                                onClick={handleSubmit}
                                                label={t('common.label.devolver')}
                                            />
                                        </div>
                                    </form>
                                )}
                            </Formik>

                        </div>

                    </div>
                </div>

            </div> : ''}
        </>

    );
};